import { fromCents } from '#src/lib/formatters/numbers';

import styles from './styles.module.scss';

const Total = ({ amountDue }) => {
  const fakeOriginalPrice = amountDue * 2;
  return (
    <div className={styles.container}>
      <div className={styles.oldAmount}>
        <strong>{fromCents(fakeOriginalPrice)}</strong>
      </div>
      <div>
        <strong>{fromCents(amountDue)}</strong>
      </div>
    </div>
  );
};

export default Total;
